import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const AnalyticsChartsWidget = ({ stats = {} }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 bg-blue-50 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-600">Total Students</span>
            <TrendingUp className="w-5 h-5 text-green-600" />
          </div>
          <p className="text-3xl font-bold text-blue-900">{stats.totalStudents || 0}</p>
        </div>

        <div className="p-4 bg-green-50 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm text-gray-600">Avg Attendance</span>
            <TrendingUp className="w-5 h-5 text-green-600" />
          </div>
          <p className="text-3xl font-bold text-green-900">{stats.avgAttendance || 0}%</p>
        </div>
      </div>

      <div className="h-48 bg-gray-100 rounded-lg flex items-center justify-center">
        <p className="text-gray-500">Chart visualization coming soon</p>
      </div>
    </div>
  );
};

export default AnalyticsChartsWidget;